export default "__VITE_ASSET__587c4351__"